/* pawty-nb-loadmore-fix.js
   Works around TWO real bugs in the base theme's "Load more" pagination
   (assets/facets.min.js -- the LoadMore custom element / lm_render_fn):
   after every AJAX append, that function is supposed to (a) swap in a
   fresh, correctly-advanced "Load more" link from the page it just
   fetched, and (b) clear the `loading` attribute it set on the outer
   `[loadmore-btn-wrapp]` div before the fetch (or remove that div
   entirely once the fetched page had no further "Load more" link of its
   own -- i.e. end of the collection). In practice that whole step
   reliably fails to run (silently -- it's wrapped in a swallowed
   try/catch), which produces BOTH bugs at once:
     1. The button's href never advances -- every click after the first
        just re-fetches and re-appends the SAME page again, forever
        (visible as duplicate products piling up).
     2. The `loading` attribute never gets cleared -- assets/theme.css's
        `.hdt-pagination-wrapp[loading]` rules hide the button's label
        and show a spinning circle via `::before`, so the button is left
        looking like a permanently-spinning, dead button even once new
        products HAVE actually loaded correctly underneath it.
   Confirmed this isn't a Liquid/pagination-settings bug -- navigating
   straight to ?page=2 server-renders a correct, non-stuck "Load more"
   button pointing at ?page=3 -- so both are purely this client-side
   step not completing.

   Fix: on every content update (products:update -- fired by both the
   load-more append and any facet/sort re-render, so a filter/sort
   change that rebuilds the grid from scratch also naturally resets our
   state instead of leaving it stuck on stale numbers), take over that
   entire step ourselves:
     - track the next page number by counting successful appends (NOT
       shown-count / per-page-count, which breaks the moment a
       collection's last page is a partial page -- e.g. 67 products at
       24/page is pages of 24/24/19, and count-math miscomputes the 3rd
       page's own "next" as page 3 again instead of 4)
     - always clear the outer wrapper's `loading` attribute and restore
       its href
     - once every product in the collection is already showing (checked
       against the collection's real total product count, fetched once
       via /products.json), remove the whole pagination wrapper --
       matching what the base theme itself does on a genuine last page
       -- instead of leaving a dead, spinning button in place. */
(function () {
  var nextPage = 2;
  var lastShown = 0;
  var total = null;

  function getGrid() {
    return document.querySelector('.hdt-collection-products, .hdt-collection-search');
  }

  function fetchTotal() {
    var m = location.pathname.match(/\/collections\/([^/]+)/);
    if (!m) return;
    fetch('/collections/' + m[1] + '/products.json?limit=250')
      .then(function (r) { return r.json(); })
      .then(function (d) { total = d.products.length; })
      .catch(function () {
        /* Not fatal -- without a known total we just skip the
           remove-at-the-end step and rely on the per-append counter alone. */
      });
  }

  function initShown() {
    var grid = getGrid();
    lastShown = grid ? grid.children.length : 0;
  }

  function fixLoadMore() {
    var grid = getGrid();
    var shown = grid ? grid.children.length : 0;

    if (shown > lastShown) {
      /* A load-more append actually grew the grid -- the page we just
         fetched is used up, move on to the next one. */
      nextPage += 1;
    } else {
      /* Grid didn't grow (or shrank) -- this is a fresh render (filter/
         sort change), not an append. Reset: next click should fetch the
         collection's own page 2 again. */
      nextPage = 2;
    }
    lastShown = shown;

    var outerWrap = document.querySelector('[loadmore-btn-wrapp]');
    var innerWrap = document.querySelector('wrapp-hdt-lm-main-url');
    if (!outerWrap || !innerWrap) return;

    if (total != null && shown >= total) {
      /* Every product in the (unfiltered) collection is already on the
         page -- there is nothing left to load. Remove the whole shell
         (button + its stuck spinner state), same as the base theme's
         own intended end-of-list behavior. */
      outerWrap.remove();
      return;
    }

    /* Clear whatever stuck loading/spinner state the base theme's own
       (failing) housekeeping left behind, and make sure the button
       itself is visible. */
    outerWrap.removeAttribute('loading');
    innerWrap.style.display = '';

    var link = innerWrap.querySelector('a[href*="page="]');
    if (!link) return;
    var url = new URL(link.href, window.location.origin);
    url.searchParams.set('page', nextPage);
    link.href = url.toString();
  }

  document.addEventListener('DOMContentLoaded', function () {
    initShown();
    fetchTotal();
  });
  document.addEventListener('products:update', fixLoadMore);
})();
